import { Link } from 'react-router-dom';
import { getLatestManga } from '@/mocks/manga';

export default function LatestUpdate() {
  const latestManga = getLatestManga().slice(0, 10);

  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-2">实时追踪<strong>漫画</strong>更新进度</p>
        </div>
      </div>

      <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
        <div className="hidden lg:grid grid-cols-12 gap-4 px-5 py-3 bg-background-100 text-xs font-semibold text-foreground-500 uppercase tracking-wide">
          <div className="col-span-5">漫画名称</div>
          <div className="col-span-2">最新章节</div>
          <div className="col-span-2">作者</div>
          <div className="col-span-2">更新时间</div>
          <div className="col-span-1">状态</div>
        </div>

        {latestManga.map((manga, index) => {
          const latestChapter = manga.chapters[manga.chapters.length - 1];
          return (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-2 lg:gap-4 px-5 py-3.5 items-center hover:bg-primary-50/50 transition-colors ${
                index !== latestManga.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="lg:col-span-5 flex items-center gap-3">
                <div className="w-9 h-12 rounded overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={manga.cover} alt={manga.title} className="w-full h-full object-cover object-top" />
                </div>
                <span className="text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors line-clamp-1">
                  {manga.title}
                </span>
              </div>
              <div className="lg:col-span-2 text-sm text-foreground-600">
                <span className="lg:hidden text-xs text-foreground-400">最新章节：</span>
                {latestChapter.title || `第${latestChapter.number}话`}
              </div>
              <div className="lg:col-span-2 text-sm text-foreground-500">
                <span className="lg:hidden text-xs text-foreground-400">作者：</span>
                {manga.author}
              </div>
              <div className="lg:col-span-2 text-sm text-foreground-500">
                <span className="lg:hidden text-xs text-foreground-400">更新：</span>
                {manga.updateTime}
              </div>
              <div className="lg:col-span-1">
                <span className={`inline-block px-2 py-0.5 text-xs rounded-full ${
                  manga.status === '连载中'
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {manga.status}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}